<template>
    <v-avatar v-if="nationalityCode" :size="size ? size : '40px'" class="flag-border">
        <img :src="this.assets()+'/flags/' + nationalityCode + '.png'">
    </v-avatar>
</template>

<script>

export default {
    props: [
        'nationalityCode',
        'size'
    ],
    data () {
        return {
        }
    },
}
</script>

<style scoped>
.flag-border{
  border: 1px solid black;
}
</style>
